import { Component, OnInit } from '@angular/core';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-positive-survey-feedback',
  templateUrl: './positive-survey-feedback.component.html',
  styleUrls: ['./positive-survey-feedback.component.scss'],
})
export class PositiveSurveyFeedbackComponent implements OnInit {

  constructor(public surveyServ: SurveyService) { }

  ngOnInit() {}

}
